import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import SevenstarForm from './SevenstarForm';
import SevenstarResult from './SevenstarResult';

/**
 * SevenstarPage — 宫廷牌七星查询（独立页面）
 *
 * 由 SevenstarModal 改造而来：同样的表单/查询逻辑，整页渲染。
 * 路由：/sevenstar
 */
export default class SevenstarPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    this.loading = false;
    this.error = null;
    this.results = null;
    this.aceResults = null;
    this.queryInfo = null;
    this.formData = this.loadDefaults();

    // 如果用户有默认城市但 cityId 未知，异步解析
    if (this.formData.cityId === '' && this.formData.cityCityName) {
      this.resolveCityId(this.formData.cityCityName);
    }
  }

  /**
   * 通过城市名搜索 cityId（异步）
   */
  resolveCityId(cityName) {
    if (!cityName) return;
    app
      .request({
        method: 'GET',
        url:
          app.forum.attribute('apiUrl') +
          '/taro/case/cities/search?q=' +
          encodeURIComponent(cityName),
      })
      .then((r) => {
        const cities = (r.cities && r.cities.data) || r.cities || [];
        if (cities.length > 0) {
          this.formData.cityId = cities[0].id || '';
          m.redraw();
        }
      })
      .catch(() => {});
  }

  /**
   * 加载默认值
   * 优先级：用户偏好 > 系统默认（武汉/东八区/当前时间）
   */
  loadDefaults() {
    const user = app.session.user;
    const prefs = (user && user.preferences && user.preferences()) || {};

    const TZ_NAME_TO_OFFSET = {
      'Asia/Shanghai': '+08:00',
      'Asia/Hong_Kong': '+08:00',
      'Asia/Taipei': '+08:00',
      'Asia/Singapore': '+08:00',
      'Asia/Tokyo': '+09:00',
      'Asia/Seoul': '+09:00',
      'UTC': '+00:00',
    };
    const tzPref = prefs.taroDefaultTimezone || 'Asia/Shanghai';
    const timezone = TZ_NAME_TO_OFFSET[tzPref] || tzPref;

    let cityId = 'CN-HB-WH';
    let cityCountry = 'CN';
    let cityProvince = 'CN-HB';
    let cityCityName = '武汉';
    if (prefs.taroDefaultCity) {
      const parts = String(prefs.taroDefaultCity).split('|');
      if (parts.length === 3) {
        cityCountry = parts[0];
        cityProvince = parts[1];
        cityCityName = parts[2];
        // 用户默认城市时，cityId 未知，先置空，稍后异步解析
        cityId = '';
      }
    }

    const now = new Date();
    const tzOffset = 8;
    const localTime = new Date(now.getTime() + tzOffset * 3600000);
    const drawDatetime =
      localTime.toISOString().slice(0, 10) + ' ' + localTime.toISOString().slice(11, 16);

    return { drawDatetime, timezone, cityId, cityCountry, cityProvince, cityCityName };
  }

  view() {
    return (
      <div className="SevenstarPage">
        <div className="container">
          <header className="SevenstarPage-header">
            <h2 className="SevenstarPage-title">
              <i className="fas fa-star" /> 宫廷牌七星查询
            </h2>
            <p className="TaroSevenstar-subtitle">
              输入抽牌时间、时区和城市，查询 16 张宫廷牌对应的七星（宫位宫主星）
            </p>
          </header>

          <div className="SevenstarPage-body TaroSevenstar">
            <SevenstarForm
              formData={this.formData}
              loading={this.loading}
              onSubmit={(data) => this.handleSubmit(data)}
            />

            {this.error && (
              <div className="TaroSevenstar-error Alert Alert--error">
                <i className="fas fa-exclamation-circle" /> {this.error}
              </div>
            )}

            {this.results && (
              <SevenstarResult
                results={this.results}
                aceResults={this.aceResults}
                queryInfo={this.queryInfo}
              />
            )}
          </div>
        </div>
      </div>
    );
  }

  handleSubmit(data) {
    this.loading = true;
    this.error = null;
    this.results = null;
    this.aceResults = null;
    m.redraw();

    app
      .request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/taro/sevenstar/query',
        body: data,
      })
      .then((response) => {
        this.loading = false;
        if (response.success) {
          this.results = response.results;
          this.aceResults = response.ace_results;
          this.queryInfo = response.query;
        } else {
          this.error = response.error || '查询失败';
        }
        m.redraw();
      })
      .catch((error) => {
        this.loading = false;
        this.error =
          (error.response && error.response.json && error.response.json.error) ||
          error.message ||
          '网络错误，请稍后重试';
        m.redraw();
      });
  }
}
